export const constant = ['tmrAppName', 'Pharmawhere Demo']
